/*
/ handle the logic to save table column related data in local storage
*/

import { ConstantTableColumn } from '../models/components/filter-object';

export function getTableColumns<T>(
    uid: string,
    tableId: string
): Array<keyof T | ConstantTableColumn> | null {
    const data = localStorage.getItem(`${uid}-column-data-${tableId}`) as
        | string
        | null;

    if (data) return JSON.parse(data) as Array<keyof T | ConstantTableColumn>;
    return null;
}

export function saveTableColumns<T>(
    uid: string,
    tableId: string,
    tableCols: Array<keyof T | ConstantTableColumn>
): void {
    localStorage.setItem(
        `${uid}-column-data-${tableId}`,
        JSON.stringify(tableCols)
    );
}

export function resetTableColumns(uid: string, tableId: string): void {
    localStorage.removeItem(`${uid}-column-data-${tableId}`);
}
